export const MESSENGER_TYPE = {
    whatsapp: "whatsapp",
    telegram: "telegram",
    viber: "viber",
    vkmax: "vkmax",
    email: "email",
};
export const SOCIAL_NETWORKS = {
  youtube: "youtube",
  tiktok: "tiktok",
  telegram: "telegram",
  instagram: "instagram"
}

// Мессенджеры, которые сотрудник может указать в профиле. Порядок задаёт вид иконок в списках,
// незаполненные показываются серыми — см. CompanyEmployees/EmployeeMessengers
export const CONTACT_MESSENGERS = [
    MESSENGER_TYPE.telegram,
    MESSENGER_TYPE.whatsapp,
    MESSENGER_TYPE.viber,
    MESSENGER_TYPE.vkmax,
];

// Названия брендов для подсказок — одинаковые во всех языках, поэтому не через i18n
export const MESSENGER_LABEL = {
    [MESSENGER_TYPE.whatsapp]: "WhatsApp",
    [MESSENGER_TYPE.telegram]: "Telegram",
    [MESSENGER_TYPE.viber]: "Viber",
    [MESSENGER_TYPE.vkmax]: "MAX",
    [MESSENGER_TYPE.email]: "Email",
};

/**
 * Приводит контакты к виду { type, login } и оставляет только те, для которых есть иконка.
 * Бэкенд отдаёт разные формы ({ type, login } и { value, messenger }), а в parser_data
 * попадаются записи вида { type: 'PHONE' } — это обычный телефон, иконки у него нет.
 * Без фильтра на их месте оставались пустые белые квадраты размером с иконку.
 */
export const getVisibleMessengers = (messengers) =>
    (Array.isArray(messengers) ? messengers : [])
        .map((item) => ({
            type: String(item?.type ?? item?.value ?? "").toLowerCase(),
            login: item?.login ?? item?.messenger ?? "",
        }))
        .filter((item) => item.login && CONTACT_MESSENGERS.includes(item.type));

export const getMessengerUrls = (messengerId) => ({
    [MESSENGER_TYPE.whatsapp]: `https://wa.me/${messengerId}`,
    [MESSENGER_TYPE.telegram]: `tg://resolve?domain=${messengerId}`,
    [MESSENGER_TYPE.viber]: `viber://chat?number=${messengerId}`,
    [MESSENGER_TYPE.vkmax]: `max://max.ru/u/${messengerId}`,
    [MESSENGER_TYPE.email]: `mailto:${messengerId}`,
    [SOCIAL_NETWORKS.youtube]: `https://youtube.com/${messengerId}`,
    [SOCIAL_NETWORKS.tiktok]: `https://tiktok.com/${messengerId}`,
    [SOCIAL_NETWORKS.telegram]: `https://t.me/${messengerId}`,
    [SOCIAL_NETWORKS.instagram]: `https://instagram.com/${messengerId}`,
});
